import { Injectable } from '@angular/core';
import { IesHttpClient } from '../../Common/ies-http-client.service';
import { AppUrl } from './../../Common/appUrl';

@Injectable()
export class AdmManageOfficeService {
 
  constructor(private _httpClient: IesHttpClient) {  
  }

  // Call API to get Exams list on Page load
  getData() {
    return this._httpClient.get(AppUrl.getOfficeDetail);   
  }

  //Add Office Record
  saveData(params: any) {
    return this._httpClient.post(AppUrl.addOffice,params);  
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-office/adm-manage-office.service.ts